import { InvoicesService_invoicesServiceGetGet } from '@festina/moneyin-general-types/moneyin/hooks/InvoicesService_invoicesServiceGetGet'

export const useLazyFetchInvoiceOverviewCollection =
  InvoicesService_invoicesServiceGetGet.useLazyQuery
